"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    PartUploader = function PartUploader(_ref) {
  var _this = this,
      partNumber = _ref.partNumber,
      url = _ref.url,
      blob = _ref.blob,
      onComplete = _ref.onComplete,
      onProgress = _ref.onProgress,
      onError = _ref.onError;

  (0, _classCallCheck2["default"])(this, PartUploader), this.uploadPart = function () {
    return new Promise(function (resolve, reject) {
      _this.xhr.open("PUT", _this.uploadUrl), _this.xhr.upload.onprogress = _this.onProgressHandler, _this.xhr.onload = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function (_context) {
          for (;;) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.prev = 0, _context.next = 3, _this.onLoadedHandler();

              case 3:
                resolve(), _context.next = 9;
                break;

              case 6:
                _context.prev = 6, _context.t0 = _context["catch"](0), reject(_context.t0.message);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      })), _this.xhr.onerror = function () {
        try {
          _this.onPartError();
        } catch (err) {
          reject(err.message);
        }
      }, _this.xhr.send(_this.blob);
    });
  }, this.onProgressHandler = function (e) {
    if (e.lengthComputable) {
      var prevBytesUploaded = _this.bytesUploaded;
      _this.bytesUploaded = e.loaded;
      var uploadedNow = e.loaded - prevBytesUploaded;

      _this.onProgress(uploadedNow);
    }
  }, this.onLoadedHandler = function () {
    return 200 === _this.xhr.status ? void _this.onPartSuccess() : void _this.onPartError();
  }, this.onPartSuccess = function () {
    var etagHeader = _this.xhr.getResponseHeader("Etag") || "",
        part = {
      PartNumber: _this.partNumber,
      ETag: etagHeader.replace(/"/g, "")
    };

    _this.onComplete(part);
  }, this.onPartError = function () {
    throw _this.onError(), _this.xhr.abort(), new Error("Part upload error");
  }, this.bytesUploaded = 0, this.xhr = new XMLHttpRequest(), this.partNumber = partNumber, this.uploadUrl = url, this.blob = blob, this.onComplete = onComplete, this.onProgress = onProgress, this.onError = onError;
},
    _default = function _default(part) {
  return new PartUploader(part);
};

exports["default"] = _default;